import provider from './provider';
import scholarship from './scholarship';
import alert from './alert';
import user from './user';
import helpdesk from './helpdesk';
import operations from './operations';
import proposalProcess from './proposalProcess';
import purchaseService from './purchaseService';
import bidQuestionConfig from './bidQuestionConfig';
import medicaid from './medicaid';
import student from './student';
import erpIntegrationLog from './erpIntegrationLog';

const routes = [
  {
    path: '/',
    meta: {
      authorization: {
        authenticated: true,
      },
    },
    component: () => import('@/views/layouts/DynamicLayout.vue'),
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
      },
      ...provider,
      ...scholarship,
      ...alert,
      ...user,
      ...helpdesk,
      ...operations,
      ...proposalProcess,
      ...purchaseService,
      ...bidQuestionConfig,
      ...medicaid,
      ...student,
      ...erpIntegrationLog,
    ],
  },
  {
    path: '/document-viewer',
    name: 'DocumentViewer',
    component: () =>
      import('@/views/provider/proposalHistory/DocumentViewer.vue'),
  },
  {
    path: '**',
    redirect: 'dashboard',
  },
  {
    path: '/',
    redirect: 'dashboard',
  },
];

export default routes;
